import ErrorPage from './ErrorPage';

const Unauthorized = () => (
  <ErrorPage header="Uh oh! You cannot access this page." subheader="Please sign in to continue." />
);

export default Unauthorized;
